import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ReadSpeaker/Toggler/Toggler.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ReadSpeaker/Toggler/Toggler.ts';

export const prototypeName = 'QVx1pXzLbli2GJdeDLyAS2Z00VDN3lf943N39WZ3IPy1zNvPAQigRvZbe3xMt84Xe2pNRVTLbXMwk4R0ij3Xo';
export {styles};
export {script};